import { FC } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CaseloadSearchSection, ICaseloadSearchCopy } from '../../caseload-search/CaseloadSearchSection';
import { InsightsCaseloadSearchState } from './InsightsCaseloadSearchState';

const SEARCH_COPY: ICaseloadSearchCopy = {
    heading: 'Ask Bea!',
    blurb: 'Your AI companion can quickly search records, investigate your questions, and analyze trends at a client or caseload level.',
    placeholder: 'Ask a question about all your clients',
    examples: [
        'Which clients came back to baseline, and what was recorded around it?',
        'Which clients had an incident, and what was recorded after it?',
        'Who has gone quiet, with no family observations lately?'
    ]
};

/** The ask box on the insights tab: the caseload search the clients page has, answered on this page. */
export const InsightsAskBea: FC = () => {
    const searchState = useInstance(InsightsCaseloadSearchState);
    return <CaseloadSearchSection searchState={searchState} copy={SEARCH_COPY} />;
};
